const BIRTHDAY_MESSAGE = "Keep an eye out when it's your birthday for a special Birthday coupon Perk from us.";
const DEFAULT_MESSAGE = 'No coupons available right now. Check back in soon!';
const DEFAULT_CONTAINER_TITLE = 'Your Available Coupons';
const ACCOUNT_DROPDOWN_TITLE = 'My Coupons';
const TITLE_MINI = 'Your coupons';
const TITLE_ATTACH_SLIDEOUT = 'You have coupons!';
const TITLE_APPLIED_COUPONS = 'Applied coupons';
const COUPONS_USAGE_MESSAGE = 'You can only use one coupon per order.';

export {
  BIRTHDAY_MESSAGE,
  DEFAULT_MESSAGE,
  DEFAULT_CONTAINER_TITLE,
  ACCOUNT_DROPDOWN_TITLE,
  TITLE_MINI,
  TITLE_ATTACH_SLIDEOUT,
  TITLE_APPLIED_COUPONS,
  COUPONS_USAGE_MESSAGE,
};
